var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdtIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3206_302696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0422 31.7696C24.8364 31.7696 31.9654 24.6972 31.9654 15.9728C31.9654 7.24847 24.8364 0.175995 16.0422 0.175995C7.24808 0.175995 0.119019 7.24847 0.119019 15.9728C0.119019 24.6972 7.24808 31.7696 16.0422 31.7696Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7395 17.4306V17.4281C17.6294 17.4357 17.0611 17.4687 15.7964 17.4687C14.7852 17.4687 14.0761 17.4408 13.8252 17.4281V17.4306C9.93659 17.2604 7.03611 16.59 7.03611 15.7849C7.03611 14.9823 9.93915 14.3093 13.8252 14.1392V16.7627C14.0787 16.7804 14.8083 16.8236 15.8144 16.8236C17.0227 16.8236 17.6268 16.7728 17.7395 16.7627V14.1417C21.6204 14.3144 24.5132 14.9849 24.5132 15.7874C24.5132 16.59 21.6179 17.2604 17.7395 17.4331M17.7395 13.87V11.5233H23.1539V7.94489H8.41339V11.5233H13.8278V13.87C9.42715 14.0706 6.11963 14.9341 6.11963 15.9703C6.11963 17.0065 9.42971 17.87 13.8278 18.0731V25.5957H17.742V18.0731C22.135 17.8725 25.4374 17.009 25.4374 15.9728C25.4374 14.9392 22.135 14.0731 17.742 13.8725",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3206_302696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtIconRound);
export default __webpack_public_path__ + "static/media/usdtIconRound.b456e04330fd6155506ab09e5ceaaede.svg";
export { ForwardRef as ReactComponent };